import { Routes, Route, Navigate } from 'react-router';
import Layout from '../layout/Layout';
import Home from '../pages/Home';
import Managers from '../pages/Managers';
import ManagerProfile from '../pages/ManagerProfile';
import Champions from '../pages/Champions';
import Weekly from '../pages/Weekly';
import DraftRoom from '../pages/DraftRoom';
import KeeperVault from '../pages/KeeperVault';
import KeeperResearchManager from '../pages/KeeperResearchManager';
import Archive from '../pages/Archive';
import Stats from '../pages/Stats';
import TheTape from '../pages/TheTape';
import Bureau from '../pages/Bureau';
import DraftGrades from '../pages/DraftGrades';
import DraftGradeDossier from '../pages/DraftGradeDossier';
import AIPicks from '../pages/AIPicks';

export default function AppRoutes() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/managers" element={<Managers />} />
        <Route path="/managers/:slug" element={<ManagerProfile />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/champions" element={<Champions />} />
        <Route path="/weekly" element={<Weekly />} />
        <Route path="/weekly/:year/:weekSlug" element={<Weekly />} />
        <Route path="/keeper-vault" element={<KeeperVault />} />
        <Route path="/predictions" element={<Navigate to="/ai-picks" replace />} />
        <Route path="/ai-picks" element={<AIPicks />} />
        <Route path="/ai-picks/:year/:weekSlug" element={<AIPicks />} />
        <Route path="/the-tape" element={<TheTape />} />
        <Route path="/bureau" element={<Bureau />} />
        <Route path="/keeper-vault/research/:slug" element={<KeeperResearchManager />} />
        <Route path="/draft-room" element={<DraftRoom />} />
        <Route path="/draft-room/:year" element={<DraftRoom />} />
        <Route path="/draft-grades" element={<DraftGrades />} />
        <Route path="/draft-grades/:slug" element={<DraftGradeDossier />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/archive/:year" element={<Archive />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
